var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnedrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#onedrive_svg__clip0_5004_8861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.776 13.536l6.425-6.186a9.709 9.709 0 00-1.622-3.445 9.644 9.644 0 00-2.817-2.55A9.585 9.585 0 0013.404.329a9.723 9.723 0 00-5.705 4.124c.056-.056 11.077 9.084 11.077 9.084z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.852 5.567a7.618 7.618 0 00-4.098-1.17h-.11a7.769 7.769 0 00-3.981 1.195 7.834 7.834 0 00-2.807 3.08 7.893 7.893 0 00.529 8.04l9.581-1.226 7.367-5.962-6.48-3.957z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.144 7.35h-.443a6.225 6.225 0 00-2.492.501l-3.877 1.672 4.265 5.35 7.643 1.895a6.444 6.444 0 00.49-4.846 6.401 6.401 0 00-3.038-3.792 5.245 5.245 0 00-2.548-.78z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.385 16.657a7.695 7.695 0 002.772 2.467A7.64 7.64 0 007.754 20h16.948a6.25 6.25 0 003.229-.9 6.302 6.302 0 002.31-2.443l-11.909-7.19-16.947 7.19z",
    fill: "#28A8EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "onedrive_svg__clip0_5004_8861"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h31v20H0z"
  })))));
}
export default SvgOnedrive;